import authUtil from './auth';

let token = '';

function setToken(newToken: string) {
  token = newToken;
}

function getToken() {
  return token;
}

// This is a separate function rather than having customToken as an
// optional param on addHeaders because we dont want people able to
// pass an empty string as the custom token and getting that replaced
// with the stored version
function addHeadersWithCustomToken(customtoken?: string) {
  if (!customtoken) {
    customtoken = authUtil.getToken() || '';
  }

  return {
    headers: {
      Authorization: `Bearer ${customtoken}`,
      'Content-Type': 'application/json',
    },
  };
}

export default { addHeadersWithCustomToken, setToken, getToken };
